"use client";

import Image from "next/image";
import { useDict } from "@/app/[lang]/providers/DictionaryProvider";
import { usePartners } from "../hooks/usePartners";
import { Skeleton } from "@/components/shadcn/skeleton";
import { HomePage } from "../type/type";

export default function Partners({ data: pageData }: { data: HomePage | undefined }) {
  const dict = useDict();
  const { data, isLoading } = usePartners();

  return (
    <div className="flex flex-col gap-10 md:gap-20 px-4 sm:px-6 md:px-0">
      <div className="flex flex-col justify-center text-center gap-6">
        <h2 className="font-bold text-3xl md:text-5xl">
          {pageData?.partners_title || dict.common?.partners || "Partners & Collaborators"}
        </h2>
      </div>

      {isLoading ? (
        <div className="flex flex-row flex-wrap justify-center gap-6 md:gap-10">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} className="w-[140px] md:w-[226px] h-[60px] rounded-lg" />
          ))}
        </div>
      ) : (
        <div className="flex flex-row justify-center gap-6 md:gap-10 flex-wrap items-center">
          {data?.data.map((partner) => (
            <a
              key={partner.id}
              href={partner.website_url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              title={partner.name}
            >
              <Image
                src={`${partner.logo_path}`}
                alt={partner.name}
                width={226}
                height={60}
                className="max-h-[60px] w-auto object-contain"
                unoptimized
              />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
